import React from 'react'
import { Container } from '@material-ui/core'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'

import RoomDetails from './components/RoomDetails/RoomDetails.jsx'
import Header from './components/Header/Header.js'
import Home from './screens/Home/Home.js'
import Auth from './components/Auth/Auth.js'
import Profile from './screens/Profile/Profile.js'
import Welcome from './screens/Welcome/Welcome.js'
import Footer from './components/Footer/Footer.js'

const App = () => {
  return (
    <BrowserRouter>
      <Container maxWidth='xl'>
        <Switch>
          <Route path='/login' exact component={Auth} />
          <>
            <Header />
            <Route path='/' exact component={() => <Redirect to='/posts' />} />
            <Route path='/posts' exact component={Home} />
            <Route path='/posts/directory/search' exact component={Home} />
            <Route path='/posts/:id' exact component={RoomDetails} />
            <Route path='/user/:username' exact component={Profile} />
            <Route path='/meow' exact component={Welcome} />
            <Footer />
          </>
        </Switch>
      </Container>
    </BrowserRouter>
  )
}

export default App
